
/*
WHAT we are using - refactor into all the files we have now. 
*/

/* eslint-disable no-unused-vars */


import { useState, useEffect, useRef, useCallback } from "react";
import { LiveAudioVisualizer  } from "react-audio-visualize";
import { useMarkdown } from "./hooks/useMarkdown";  
import { motion } from "framer-motion";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm"; 
import Typewriter from 'typewriter-effect/dist/core';


import './App.css';

import logo from './images/bird_logo_big2.svg';
import logo_pet from './images/bird_logo_big_pet2.svg'
import logo_music from './images/bird_logo_music_recolor.svg';
import logo_code from './images/bird_logo_code.svg';
import logo_picture from './images/bird_logo_big_picture2.svg';
import trustfall from './music/trustfall-cut.mp3';
import wrtb from './music/wrtb-sample.mp3';
import hiphop_chart from './images/umap_Experimental_Hip-Hop.png';
import fullcanvas from './images/fullcanvas.png'

import instagram from './images/social-media/instagram-logo.png'
import soundcloud from './images/social-media/soundcloud-logo-CROP.png'
import github from './images/social-media/GitHub_Invertocat_White.png'
import youtube from './images/social-media/youtube-app-white-icon.png'

import demoMp4 from './videos/launchpad-demo-2.mp4'; // adjust path



const TIME = 300; // ms 
const FLY = 480;          // ms 
const BG_DELAY = 300; // ms, delay before bg color transition
const TITLE_DELAY = 500; // ms, delay before showing title


// const TIME = 0; // ms 
// const FLY = 0;          // ms 
// const BG_DELAY = 0; // ms, delay before bg color transition
// const TITLE_DELAY = 0; // ms, delay before showing title



const TARGET_VH = 16; // vh, target height of logo when in corner
const PADDING = 16; // px, padding from edges when in corner
const OFFSET_VW = 0; // vw, extra offset to avoid edge  

const GAP_TOP = 16; // bird/pane gap

// todo change purple 
const BG = {
  idle:  "#000210ff",   // current
  music: "#080605ff",   // deep purple/indigo (tweak)
  code:  "#0a0e0dff",   // teal-ish (tweak)
  picture: "#07110bff" // dark green 
};

const BIRDCOLORS = {
  blue: "#55A1E6",
  purple: "#6741d9", // rgb(103 65 217)
  green: "#2f9e44", // rgb(47 158 194)
  white: "#1e1e1e" 
}

const imgCache = new Map(); // src -> Promise<void>

function ensureImage(src) {
  if (!imgCache.has(src)) {
    const p = new Promise((resolve) => {
      const i = new Image();
      i.onload = () => resolve();
      i.onerror = () => resolve();   // don't block if it fails
      i.src = src;
      if (i.decode) i.decode().then(resolve).catch(resolve); // modern browsers
    });
    imgCache.set(src, p);
  }
  return imgCache.get(src);
}

// Live bar that records from an <audio> element and avoids the bird.
function CornerVisualizer({
  audioRef,
  corner = "right",          // "left" | "right"
  birdElRef = null,          // ref to wrapper or <img>
  titleRef = null,           // ref to the "music" label
  padTop = 16,               // top padding
  padLeft = 0,               // ← start flush with the left edge
  padRight = 0,             // right padding
  gapToBird = 0,             // horizontal gap between bars and bird
  height = 48,
  overlapPx = 0,

}) {
  const [rec, setRec] = useState(null);
  const [box, setBox] = useState({ left: padLeft, width: 0, top: padTop, dynH: height });

  const computeBox = useCallback(() => {
    const titleEl = titleRef?.current || null;
    const birdEl  = birdElRef?.current || null;
    const birdImg = birdEl?.querySelector?.("img") || birdEl;

    const tr = titleEl ? titleEl.getBoundingClientRect() : null;
    const br = birdImg ? birdImg.getBoundingClientRect() : null;

    // vertical: center on title (fallback to padTop)


    const dynH = Math.max(64, Math.round(Math.max(tr?.height || 0, br?.height || 0) * 0.7));
    const top = tr ? tr.top + tr.height / 2 - dynH / 2 : padTop;


    let left = padLeft;
    let width = Math.max(0, window.innerWidth - padLeft - padRight);

    if (br) {
      if (corner === "right") {
        
        // from very left to bird’s left edge
        left = padLeft; // 0 for flush
        width = Math.max(0, br.left + overlapPx - gapToBird - left);
        console.log({left, width, br, gapToBird});
      } else {
        // from bird’s right edge to the right edge
        left = br.right + gapToBird;
        width = Math.max(0, window.innerWidth - padRight - left + overlapPx);
      }
    }

    setBox({ left, width, top, dynH });
  }, [birdElRef, titleRef, corner, padTop, padLeft, padRight, gapToBird, overlapPx]);

  useEffect(() => { computeBox(); }, [computeBox]);
  useEffect(() => {
    const onResize = () => computeBox();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [computeBox]);

  // MediaRecorder hookup (unchanged)
useEffect(() => {
  const el = audioRef?.current;
  if (!el) return;

  let mr = null;
  let stopping = false;

  const makeRecorder = () => {
    const stream = el.captureStream ? el.captureStream() : el.mozCaptureStream?.();
    if (!stream) return null;

    const next = new MediaRecorder(stream);

    next.onstop = () => {
      if (mr === next) {
        mr = null;
        setRec(null);
      }
      stopping = false;
    };

    next.onerror = (e) => {
      console.warn("MediaRecorder error:", e);
      if (mr === next) {
        mr = null;
        setRec(null);
      }
      stopping = false;
    };

    return next;
  };

  const startMR = () => {
    try {
      // Already recording or waiting for old recorder to finish stopping.
      if (stopping) return;
      if (mr && mr.state === "recording") return;
      if (mr && mr.state !== "inactive") return;

      mr = makeRecorder();
      if (!mr) return;

      mr.start();
      setRec(mr);
    } catch (e) {
      console.warn("MediaRecorder start failed:", e);
      mr = null;
      setRec(null);
      stopping = false;
    }
  };

  const stopMR = () => {
    try {
      if (!mr) {
        setRec(null);
        return;
      }

      if (mr.state === "recording" || mr.state === "paused") {
        stopping = true;
        mr.stop();
      } else {
        mr = null;
        setRec(null);
        stopping = false;
      }
    } catch (e) {
      console.warn("MediaRecorder stop failed:", e);
      mr = null;
      setRec(null);
      stopping = false;
    }
  };

  const onPlay = () => startMR();
  const onPause = () => stopMR();
  const onEnded = () => stopMR();

  el.addEventListener("play", onPlay);
  el.addEventListener("pause", onPause);
  el.addEventListener("ended", onEnded);

  if (!el.paused) startMR();

  return () => {
    el.removeEventListener("play", onPlay);
    el.removeEventListener("pause", onPause);
    el.removeEventListener("ended", onEnded);
    stopMR();
  };
}, [audioRef]);

  if (!rec || box.width <= 0) return null;

  // Scaling stuff
  const TARGET_PITCH = 6; // px/bar

  const rawBar = Math.max(1, Math.floor(TARGET_PITCH * 0.8));
  const rawGap = Math.max(1, TARGET_PITCH - rawBar);

  const barWidth = rawBar;
  const gap = rawGap; 



  return (
    <div
      style={{
        position: "fixed",
        top: box.top,
        left: box.left,
        width: box.width,
        height: box.dynH ?? 48,     // fallback height
        pointerEvents: "none",
        zIndex: 15,                  // under the bird (bird is zIndex: 20)
      }}
    >
      {/* MediaRecorder-based bars */}
      <LiveAudioVisualizer
        mediaRecorder={rec}
        width={box.width}
        height={box.dynH ?? 48}
        barWidth={barWidth}
        gap={gap}
        // barColor="rgba(126, 68, 141, 0.64)"
        // barColor="rgba(103, 65, 217, 0.64)"
        barColor="rgba(142, 72, 192, 0.64)"
        barPlayedColor="rgba(133, 0, 0, 0.95)"
        fftSize={1024}
        smoothingTimeConstant={0.75}
        maxDecibels={-1}
      />

      {/* WebAudio log/EQ bars — make it fill the container */}
      <CustomLogVisualizer
        audioRef={audioRef}
        width={box.width}
        height={box.dynH ?? 48}
        bars={64}
        smoothing={0.6}
        tilt={0.2}
        color="rgba(255,255,255,0.95)"
        // inside CustomLogVisualizer, render your <canvas> like:
        // <canvas style={{ position:'absolute', inset:0, width:'100%', height:'100%' }} />
      />
    </div>
  );

}

// ---- shared AudioContext + element->source cache ----
const getSharedAudioContext = (() => {
  let ac;
  return () => (ac ??= new (window.AudioContext || window.webkitAudioContext)());
})();

const elementSources = new WeakMap(); // HTMLMediaElement -> MediaElementSourceNode

function getSourceForElement(el) {
  let src = elementSources.get(el);
  if (!src) {
    const ac = getSharedAudioContext();
    src = ac.createMediaElementSource(el);
    elementSources.set(el, src);
  }
  return src;
}

// Keep this with your other shared state:
const connectedSources = new WeakSet(); // tracks which sources are routed to output

function ensureOutputConnected(src) {
  if (!connectedSources.has(src)) {
    try {
      src.connect(getSharedAudioContext().destination);
      connectedSources.add(src);
    } catch {}
  }
}




function CustomLogVisualizer({
  audioRef,
  left,
  top,
  width,
  height,
  bars = 64,                  // more bars → denser look
  smoothing = 0.7,            // 0..1 temporal smoothing
  minDecibels = -90,
  maxDecibels = -10,
  tilt = 0.6,                 // boost highs visually; 0.4–0.8 is nice
  color = "rgba(255,255,255,0.95)",
  bg = "transparent",
}) {
  const canvasRef = useRef(null);
  const rafRef = useRef(0);
  const ctxRef = useRef(null);
  const analyserRef = useRef(null);
  const dataRef = useRef(null);
  const acRef = useRef(null);
  const srcRef = useRef(null);
  const createdRef = useRef(false); // StrictMode guard


  // attach WebAudio graph to the <audio> element
  useEffect(() => {
    if (createdRef.current) return;        // prevent StrictMode double-exec
    createdRef.current = true;

    const el = audioRef?.current;
    if (!el) return;

    const ac = getSharedAudioContext();
    acRef.current = ac;

    const src = getSourceForElement(el);
    srcRef.current = src;

    const analyser = ac.createAnalyser();
    analyser.fftSize = 512;
    analyser.smoothingTimeConstant = 0.3;
    analyser.minDecibels = -30.1;
    analyser.maxDecibels = -10;

    // connect a parallel tap: src -> analyser -> destination
    // (don’t also re-connect src->destination here to avoid double volume)
    try {
      src.connect(analyser);
      ensureOutputConnected(src);
    } catch (e) {
      // If HMR re-runs and connections already exist, connect() may throw; safe to ignore.
      // console.debug("connect() warn:", e);
    }

    analyserRef.current = analyser;
    

    // resume on play (mobile)
    const resume = () => ac.state === "suspended" && ac.resume().catch(() => {});
    el.addEventListener("play", resume);

    return () => {
      el.removeEventListener("play", resume);
      // Disconnect only our analyser to keep the shared source alive
      try { analyser.disconnect(); } catch {}
      cancelAnimationFrame(rafRef.current);
    };
  }, [audioRef]);

  // draw loop
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const dpr = Math.max(1, window.devicePixelRatio || 1);
    canvas.width = Math.max(1, Math.floor(width * dpr));
    canvas.height = Math.max(1, Math.floor(height * dpr));
    canvas.style.width = `${width}px`;
    canvas.style.height = `${height}px`;

    const ctx = canvas.getContext("2d");
    ctxRef.current = ctx;

    const analyser = analyserRef.current;
    const freq = dataRef.current;
    if (!analyser || !freq) return;

    // log mapping helpers
    const nyquist = (acRef.current?.sampleRate || 48000) / 2;
    const binHz = nyquist / analyser.frequencyBinCount;

    const barFreq = (i) => {
      // log space from ~40 Hz to nyquist
      const fMin = 40;
      const f = fMin * Math.pow(nyquist / fMin, i / Math.max(1, bars - 1));
      return Math.min(f, nyquist);
    };

    const freqToIndex = (f) => Math.min(
      analyser.frequencyBinCount - 1,
      Math.max(0, Math.round(f / binHz))
    );

    const path = new Array(bars).fill(0).map((_, i) => {
      const f1 = barFreq(i);
      const f2 = barFreq(i + 1);
      const i1 = freqToIndex(f1);
      const i2 = freqToIndex(f2);
      return [i1, Math.max(i1 + 1, i2)];
    });

    // auto-gain buffer (track 90th percentile)
    let gain = 1;
    let smoothGain = 1;

    const draw = () => {
      analyser.getByteFrequencyData(freq);

      // compute bar magnitudes with tilt (pre-emphasis for highs)
      const mags = path.map(([a, b], i) => {
        let sum = 0;
        for (let k = a; k < b; k++) sum += freq[k];
        const avg = sum / Math.max(1, b - a);
        const t = Math.pow(i / Math.max(1, bars - 1), tilt); // 0..1 → tilt up highs
        return avg * (0.6 + 0.4 * (1 + t)); // baseline + tilt boost
      });

      // estimate 90th percentile for auto gain
      const sorted = [...mags].sort((x, y) => x - y);
      const p90 = sorted[Math.floor(sorted.length * 0.9)] || 1;
      gain = Math.max(1, p90);
      smoothGain = smoothGain * 0.9 + gain * 0.1;

      // clear
      ctx.save();
      ctx.scale(dpr, dpr);
      if (bg !== "transparent") {
        ctx.fillStyle = bg;
        ctx.fillRect(0, 0, width, height);
      } else {
        ctx.clearRect(0, 0, width, height);
      }

      // bar geometry
      const gap = Math.max(1, Math.floor(width / (bars * 8))); // thin gaps
      const barW = Math.max(1, Math.floor((width - gap * (bars - 1)) / bars));

      ctx.fillStyle = color;

      for (let i = 0; i < bars; i++) {
        const x = i * (barW + gap);
        // normalize to canvas height
        const norm = Math.min(1, mags[i] / smoothGain);
        const h = Math.max(2, norm * height);
        const y = height - h;
        ctx.fillRect(x, y, barW, h);
      }

      ctx.restore();
      rafRef.current = requestAnimationFrame(draw);
    };

    cancelAnimationFrame(rafRef.current);
    rafRef.current = requestAnimationFrame(draw);

    return () => cancelAnimationFrame(rafRef.current);
  }, [width, height, bars, color, bg, tilt]);

  if (width <= 0 || height <= 0) return null;

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: "fixed",
        left,
        top,
        width,
        height,
        pointerEvents: "none",
        zIndex: 9998,
      }}
    />
  );
}

// Second container for text.
export default function App() {


  const [currentLogo, setCurrentLogo] = useState(logo);
  const [isPetting, setIsPetting] = useState(false);
  


  const [showBird, setShowBird] = useState(false); // optional: from prior answer  
  const [stacked, setStacked] = useState(false); // optional: from prior answer 
  const [birdHop, setBirdHop] = useState(false);

  const [flipStage, setFlipStage] = useState(""); // optional: from prior answer
  const [translateX, setTranslateX] = useState(0);

  const [stage, setStage] = useState("idle");
  const [flyStyle, setFlyStyle] = useState(null);

  const [showPane, setShowPane] = useState(false); // "music" | "code" | null  

  const [btnVisible, setBtnVisible] = useState(false);

  const [branchTitle, setBranchTitle] = useState(null);              // "music" | "code" | null
  const [branchTitleStyle, setBranchTitleStyle] = useState({});      // computed pos/size

  const [showTitle, setShowTitle] = useState(false); // optional: from prior answer 

  const [titleMounted, setTitleMounted] = useState(true);
  const [titleVisible, setTitleVisible] = useState(true);

  const measureRef = useRef(null);
  const [twMinWidth, setTwMinWidth] = useState(0);
  const [twMeasured, setTwMeasured] = useState(false);

  const [isFlipping, setIsFlipping] = useState(false);
  const [frozenX, setFrozenX] = useState(0);

  const [branchLabelVisible, setBranchLabelVisible] = useState(false);
  
  const buttonWrapRef = useRef(null);
  const [buttonFreezeStyle, setButtonFreezeStyle] = useState(null);


  const [activeAudioEl, setActiveAudioEl] = useState(null);
  const audioElsRef = useRef([]);


  const twRef = useRef(null);
  const logoWrapRef = useRef(null);
  const rowRef = useRef(null);

  const parkedCornerRef = useRef(null);   // "left" | "right" | null
  const parkedRectRef   = useRef(null);   // the rect we used at takeoff
  const parkedScaleRef  = useRef(1);      // the scale we used at takeoff

  const branchTitleRef = useRef(null);

  const openl3Notes = useMarkdown("/descs/openl3-layman.md");
  const launchpad = useMarkdown("/descs/launchpad.md");
  const spicetify = useMarkdown("/descs/spicetify-rym.md");
  const electronicsNotes = useMarkdown("/descs/electronics.md")

  const emailHref = `mailto:blujay.nest@pm.me?subject=${encodeURIComponent(
    "[Access request / query!]"
  )}&body=${encodeURIComponent("Hi Jay,\n\n")}`;

  const isTitleVisible = stage === "idle" && showTitle && titleVisible;
    const updateBirdPosition = useCallback(() => {
      const textEl = twRef.current;
      const logoEl = logoWrapRef.current;
      const rowEl = rowRef.current;
      if (!textEl || !logoEl || !rowEl) return;

      const mqMobile = window.matchMedia("(max-width: 640px)").matches || window.matchMedia("(pointer: coarse)").matches;
      const GAP = 0; // px, gap between logo and text
      const typedW    = textEl.offsetWidth;   // ← remove /10
      const logoW     = logoEl.offsetWidth;
      const rowW      = rowEl.offsetWidth;


      const isMobileLike =
        window.matchMedia("(max-width: 640px)").matches ||
        window.matchMedia("(pointer: coarse)").matches;

      // On landing & mobile-like: force stacked and skip sliding
      if (stage === "idle" && isMobileLike) {
        if (!stacked) setStacked(true);
        setTranslateX(0);
        return;
      }

      const shouldStack = mqMobile || (typedW + logoW + GAP > rowW);

      setStacked(prev => (prev !== shouldStack ? shouldStack : prev));



      // mobile: stack, no slide
      const isMobile = window.matchMedia("(max-width: 320px)").matches;
      if (isMobile || (stage !== "idle" && !flyStyle)) {
        setTranslateX(0);
        return;
      }

      
      const typedWidth = textEl.offsetWidth; // width of typed content
      const logoWidth = logoEl.offsetWidth;
      const rowWidth = rowEl.offsetWidth;

      const maxX = Math.max(0, rowWidth - logoWidth);
      setTranslateX(Math.min(typedWidth, maxX));

    }, [stage, flyStyle, stacked]);




    const registerAudio = (el) => {
      if (el && !audioElsRef.current.includes(el)) {
        audioElsRef.current.push(el);
      }
    };

    const handleAudioPlay = (playingEl) => {
      // set this track as the one visualiser listens to
      setActiveAudioEl(playingEl);

      // pause every other audio player
      audioElsRef.current.forEach((el) => {
        if (el && el !== playingEl) {
          el.pause();
        }
      });
    };

    

    useEffect(() => {
      const onResize = () => updateBirdPosition();
      window.addEventListener("resize", onResize);
      updateBirdPosition(); // initial
      return () => window.removeEventListener("resize", onResize);
    }, [updateBirdPosition]);

     useEffect(() => {
      if (stage !== "idle") {
        setBtnVisible(false);
        return;
      }

      const id = setTimeout(() => {
        setBtnVisible(true);
      }, 4000);

      return () => clearTimeout(id);
    }, [stage]);

    useEffect(() => {
    const calc = () => {
      if (!measureRef.current) return;
      const w = measureRef.current.getBoundingClientRect().width;
      setTwMinWidth(w);
      setTwMeasured(true);
    };
    calc();
    window.addEventListener("resize", calc);
    return () => window.removeEventListener("resize", calc);


}, []);



  // // when branching (stage !== idle) → fade out, then unmount after the transition
  // useEffect(() => {
  //   if (stage !== "idle") {
  //     setBtnVisible(false);                // start fade out
  //     const id = setTimeout(() => setBtnMounted(false), TIME); // remove from layout after fade
  //     return () => clearTimeout(id);
  //   }
  // }, [stage]);

  useEffect(() => {
    if (stage !== "idle") {
      // fade out, then unmount
      setTitleVisible(false);
      const id = setTimeout(() => setTitleMounted(false), TIME);
      return () => clearTimeout(id);
    } else {
      // mount, then fade in
      setTitleMounted(true);
      const id = setTimeout(() => setTitleVisible(true), 20);
      return () => clearTimeout(id);
    }
  }, [stage]);


  // Update bird position on window resize
  useEffect(() => { 
    const onResize = () => {
      const corner  = parkedCornerRef.current;
      const baseRec = parkedRectRef.current;
      if (!corner || !baseRec) return; // only after parking

      // recompute scale from TARGET_VH
      const targetPx = Math.max(1, (window.innerHeight * TARGET_VH) / 100);
      const SCALE    = Math.min(1, targetPx / baseRec.height);
      parkedScaleRef.current = SCALE;

      const targetTop  = PADDING;
      const targetLeft = corner === "left"
        ? PADDING
        : window.innerWidth - baseRec.width - PADDING;

      const offsetPx = (OFFSET_VW / 100) * window.innerWidth;
      const tx       = corner === "left" ? -offsetPx : +offsetPx;

      setFlyStyle(prev => prev ? {
        ...prev,
        top: targetTop,
        left: targetLeft,
        transform: `scale(${SCALE}) translateX(${tx}px)`,
        zIndex: 50,
      } : prev);
  };

    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
    // put top-level


  useEffect(() => {
    // warm the cache
    [logo, logo_music, logo_code].forEach(ensureImage);
  }, []);

  useEffect(() => {
  const mq = window.matchMedia("(max-width: 640px)");
  const coarse = window.matchMedia("(pointer: coarse)");
  const apply = () => setStacked(mq.matches || coarse.matches);

  // Visualiser stuff


  apply(); // initial
  mq.addEventListener("change", apply);
  coarse.addEventListener("change", apply);
  return () => {
    mq.removeEventListener("change", apply);
    coarse.removeEventListener("change", apply);
  };
}, []);


  useEffect(() => {
    let timeoutId;

    const scheduleHop = () => {
      const delay = 2000; // 5–10 seconds

      timeoutId = setTimeout(() => {
        // Only hop on landing page, not when bird is parked in music/code corner
        if (stage === "idle") {
          setBirdHop(true);

          setTimeout(() => {
            setBirdHop(false);
            scheduleHop();
          }, 650);
        } else {
          scheduleHop();
        }
      }, delay);
    };

    scheduleHop();

    return () => clearTimeout(timeoutId);
  }, [stage]);

  useEffect(() => {
    if (!twRef.current) return;
    const tw = new Typewriter(twRef.current, {
      autoStart: false,
      delay: 80,
    });

    // const rand = (min, max) => Math.floor(min + Math.random() * (max - min + 1));
    const title = "blujay";

    const titleTimer = setTimeout(() => {
      setShowTitle(true);  // let the H1 fade in
      let chain = tw.pauseFor(0);
        for (const ch of title) {
          chain = chain.typeString(ch).callFunction(updateBirdPosition);
        }
        chain.start();
    }, TITLE_DELAY);


    const t2 = setTimeout(() => setShowBird(true), 0); // optional: from prior answer
        
    return () => {
      clearTimeout(titleTimer);
      clearTimeout(t2);
    };
    // optional cleanup

  }, [updateBirdPosition]);

  const flipTo = async (nextSrc, afterFlip) => {
    // ensure the next image is decoded
    await ensureImage(nextSrc);
    setIsFlipping(true);
    setFrozenX(translateX);

    // run your flip out → swap → flip in
    setFlipStage("out");

    // let the 'out' class apply
    requestAnimationFrame(() => {
      setTimeout(() => {
        setCurrentLogo(nextSrc);       // swap only once decoded
        setFlipStage("in");
        setTimeout(() => {
          setFlipStage("");
          setIsFlipping(false);
          if (afterFlip) afterFlip();
        }, 220);
      }, 220);
    });
  };

  useEffect(() => {
    const calc = () => {
      if (!measureRef.current) return;
      setTwMinWidth(measureRef.current.getBoundingClientRect().width);
    };
    calc();
    window.addEventListener("resize", calc);
    return () => window.removeEventListener("resize", calc);
}, []);


// For bird petting :3
const handleLogoMouseMove = (e) => {
  const img = e.currentTarget.querySelector("img");
  if (!img) return;

  const r = img.getBoundingClientRect();

  const x = (e.clientX - r.left) / r.width;   // 0 = left, 1 = right
  const y = (e.clientY - r.top) / r.height;   // 0 = top, 1 = bottom

  // rough head area - tweak these
  const onHead =
    x > 0.65 &&
    x < 0.85 &&
    y > 0.35 &&
    y < 0.60;

  setIsPetting(onHead);
};

const handleLogoMouseLeave = () => {
  setIsPetting(false);
};

// put near your other constants
const flyToCorner = (corner, label) => {
  const img = logoWrapRef.current?.querySelector("img");
  if (!img) return;

  const rect = img.getBoundingClientRect();

  parkedCornerRef.current = corner;
  parkedRectRef.current   = rect;


  const targetPx  = Math.max(1, (window.innerHeight * TARGET_VH) / 100);
  const SCALE     = Math.min(1, targetPx / rect.height);   // never grow, only shrink
  parkedScaleRef.current = SCALE;


  setFlyStyle({
    position: "fixed",
    top: rect.top,
    left: rect.left,
    width: rect.width,
    height: rect.height,
    transform: "scale(1)",
    transformOrigin: corner === "left" ? "top left" : "top right",
    transition: `top ${FLY}ms ease, left ${FLY}ms ease, transform ${FLY}ms ease`,
    zIndex: 20,
  });

  const baseFontPx = Math.max(12, Math.round(rect.height * 0.28)); // ~28% of bird height
  const GAP = 10; // px gap between bird and label (will scale too)



  const common = {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",   // <- vertically centers to the bird
    fontSize: `${baseFontPx}px`,
    lineHeight: 1,
    whiteSpace: "nowrap",
    pointerEvents: "none",
};

  // TEMP FIX - change if wanting to change where picture bird goes
 setBranchTitle(label ?? (corner === "left" ? "code" : "music"));
  setBranchTitleStyle(
    corner === "left"
      ? { ...common, left: `calc(100% + ${GAP}px)`,  textAlign: "left" }
      : { ...common, right:`calc(100% + ${GAP}px)`, textAlign: "right" }
  );


  requestAnimationFrame(() => {
    const targetTop = PADDING;
    const targetLeft = corner === "left"
      ? PADDING
      : window.innerWidth - rect.width - PADDING;

    // convert vw → px once per fly
    const offsetPx = (OFFSET_VW / 100) * window.innerWidth;
    // for left corner: nudge further left (negative); right corner: further right (positive)
    const tx = corner === "left" ? -offsetPx : +offsetPx;

    setFlyStyle(prev => prev ? {
      ...prev,
      top: targetTop,
      left: targetLeft,
      transform: `scale(${SCALE}) translateX(${tx}px)`,
    } : prev);

    setTimeout(() => setShowPane(true), FLY + 40);
    const LABEL_EXTRA = 100;
    setBranchLabelVisible(false);
    setTimeout(() => setBranchLabelVisible(true), FLY + LABEL_EXTRA);

  });
};

const landingButtonsVisible = stage === "idle" && btnVisible;


  const goToStage = (nextStage, nextLogo, corner, label) => {
    if (stage !== "idle") return;

    setIsPetting(false);

    // Fade landing UI while it is still in its original layout
    setBtnVisible(false);
    setTitleVisible(false);

    flipTo(nextLogo, () => {
      // Measure and fix bird position BEFORE changing stage layout
      flyToCorner(corner, label);

      // Now change stage after bird has already become fixed-position
      setStage(nextStage);
    });
  };

  // todo UNDERLINE _onMusic when UNUSED

  const onMusic = () => {
    goToStage("music", logo_music, "right", "music");
  };

  const onCode = () => {
    goToStage("code", logo_code, "left", "code");
  };

  const onPicture = () => {
    goToStage("picture", logo_picture, "left", "pictures");
  };
    

  const dimEverything = stage !== "idle";
  //const setShowons   = dimEverything || !showButtons; // not used


  return (
    <div
      style={{
        ...styles.container,
        overflowY: stage === "idle" ? "hidden" : "auto",
        overflowX: "hidden",
        justifyContent: stage === "idle" ? "center" : "flex-start",
        backgroundColor: BG[stage],
        transition: `background-color ${TIME * 3}ms ease ${
          stage === "idle" ? "0ms" : `${BG_DELAY}ms`
        }`,
      }}
    >
      <div style={styles.content}>
        {/* add ref to the row */}
        <div
          ref={rowRef}
          aria-hidden={dimEverything}
          style={{
            ...styles.logoText,
            flexDirection: stacked ? "column" : "row",
            alignItems: "center",
            gap: stacked ? "0.5rem" : "1rem",
            pointerEvents: dimEverything ? "none" : "auto",  

          }}
        >
          {/* add ref + transform/transition to logoContainer */}
          <div
            ref={logoWrapRef}
            onMouseMove={handleLogoMouseMove}
            onMouseLeave={handleLogoMouseLeave}
            
            style={{
              ...styles.logoContainer,
              opacity: showBird ? 1 : 0,
              transformOrigin: "top left",  // ← fade
              transform: (!stacked && stage === "idle") ? `translateX(${-(isFlipping ? frozenX : translateX)/10}px)` : "none",
              transition: `${(!stacked && stage === "idle") ? `transform ${TIME}ms ease-out, ` : ""}opacity ${TIME}ms ease`,
              zIndex: stage !== "idle" ? 20 : 1,  // ← include opacity
              position: flyStyle?.position || "static",
              
              ...(flyStyle || {}), // if you later use fly-to-corner, keep this last
            }}
          ><div
                className={`logo-anim ${flipStage ? `flip-${flipStage}` : ""} ${birdHop ? "bird-hop" : ""}`}              style={{ 
                position: "relative",
                height: "clamp(140px, 30vh, 320px)",
                aspectRatio: "1 / 1",
                width: "auto",
              }}
            >
              {/* normal/current bird */}
              <img
                src={currentLogo}
                alt="logo"
                style={{
                  ...styles.logo,
                  position: "absolute",
                  inset: 0,
                  height: "100%",
                  width: "100%",
                  objectFit: "contain",
                  opacity: isPetting && currentLogo === logo ? 0.0 : 1,
                  transition: isPetting
                    ? "opacity 320ms ease 80ms"
                    : "opacity 180ms ease",
                }}
              />

              {/* pet overlay only for original landing bird */}
              {currentLogo === logo && (
                <img
                  src={logo_pet}
                  alt=""
                  aria-hidden="true"
                  style={{
                    ...styles.logo,
                    position: "absolute",
                    inset: 0,
                    height: "100%",
                    width: "100%",
                    objectFit: "contain",
                    opacity: isPetting ? 1 : 0,
                    transition: isPetting
                      ? "opacity 160ms ease"
                      : "opacity 500ms ease",
                    pointerEvents: "none",
                  }}
                />
              )}
            </div>
            {branchTitle && (
            <span
              ref={branchTitleRef}
              style={{
                pointerEvents: "none",
                lineHeight: 1,
                fontFamily: "Bitcounter, Courier New, monospace",
                fontWeight: "bold",
                letterSpacing: "0.02em",
                color: "white",
                opacity: branchLabelVisible ? 0.9 : 0,
                textTransform: "lowercase",
                justifyContent: "center",
                marginTop: stacked ? `${GAP_TOP}px` : 0, // gap if stacked
                ...branchTitleStyle, // absolute side + fontSize computed in flyToCorner
                transition: `opacity ${TIME}ms ease`,
                
              }}
              aria-hidden={stage === "idle"}
            >
              {branchTitle}
            </span>
          )}
          </div>

          {titleMounted && (
            <div
              style={{
                ...styles.titleColumn,
                alignItems: "center",
              }}
            >
              <h1
                style={{
                  ...styles.text,
                  whiteSpace: stacked ? "normal" : "nowrap",
                  textAlign: "center",
                  opacity: isTitleVisible ? 1 : 0,
                  transition: `opacity ${TIME}ms ease, filter ${TIME}ms ease`,
                }}
              >
                <span
                  style={{
                    display: "inline-block",
                    minWidth: twMeasured ? twMinWidth : "6ch",
                    textAlign: "center",
                    visibility: twMeasured ? "visible" : "hidden",
                  }}
                >
                  <span
                    className="typewrap"
                    style={{ visibility: showTitle ? "visible" : "hidden" }}
                  >
                    <span ref={twRef} />
                  </span>
                </span>
              </h1>

              <div
                style={{
                  ...styles.socialLinks,
                  opacity: landingButtonsVisible ? 1 : 0,
                  pointerEvents: landingButtonsVisible ? "auto" : "none",
                  transition: `opacity ${TIME}ms ease`,
                }}
                aria-hidden={!landingButtonsVisible}
              >
                <LogoLink
                  icon={instagram}
                  alt="Instagram"
                  href="https://instagram.com/blujay.mp3"
                />

                <LogoLink
                  icon={youtube}
                  alt="YouTube"
                  href="https://www.youtube.com/@blujay-mp3"
                />

                <LogoLink
                  icon={soundcloud}
                  alt="SoundCloud"
                  href="https://soundcloud.com/blujay-376774419"
                />

                <LogoLink
                  icon={github}
                  alt="GitHub"
                  href={emailHref}
                />
              </div>

              <span
                ref={measureRef}
                style={{
                  position: "absolute",
                  visibility: "hidden",
                  whiteSpace: "nowrap",
                  fontFamily: styles.text.fontFamily || "Courier New",
                  fontSize: styles.text.fontSize,
                  lineHeight: styles.text.lineHeight || 1,
                  fontWeight: "normal",
                  letterSpacing: "normal",
                }}
              >
                blujay
              </span>
            </div>
          )}

        </div>

    <div
      style={{
        ...styles.buttonWrap,
        opacity: btnVisible ? 1 : 0,
        pointerEvents: btnVisible ? "auto" : "none",
        transition: `opacity ${TIME}ms ease`,
      }}
    >

    <div style={styles.splashText2}>
       <span style={{ color: BIRDCOLORS.blue, fontSize: 24 }}>Site WIP!!! check back soon &lt;3</span> 
    </div>
    <div style={styles.buttonContainer}>
      <button style={styles.button} onClick={onMusic}>music</button>
    </div>

    <div style={styles.buttonContainer}>
      <button style={styles.button} onClick={onCode}>code</button>
    </div>

    <div style={styles.buttonContainer}>
      <button style={styles.button} onClick={onPicture}>pictures</button>
    </div>
  </div>
          
      </div>
{/* MUSIC PANE */}
{showPane && stage === "music" && (
  <>
  
  <ProjectsPane
      side="right"
      items={[
        {
          title: "Full CDJ mix",
          sub: "[electro house, trance, hyperpop, techno] - May 2026",
          desc: "First studio session! Originally a rehearsal for a live set but later found it more suitable for streaming at home. A full hour cross-genre set of me mixing my favourite tracks into eachother... didn't expect to leave with something I'd be happy posting so I'm glad I can share something like this so soon! Mostly a way of me establishing my taste to whoever's interested - setlist on youtube!!",
               content: ( 
                
        <div style={{ display: "grid", gap: 8 }}>
          
          <div
            style={{
              position: "relative",
              width: "10%",
              aspectRatio: "16 / 9",
              borderRadius: 12,
              overflow: "hidden",
              background: "black",
            }}
            
          >
            
            {/*
            <iframe
              
              src="https://www.youtube.com/embed/W59Sp8qKs7g?si=PnNvMVSDkPhvzCXi"
              title="Full CDJ mix"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              style={{
                position: "absolute",
                inset: 0,
                width: "100%",
                height: "100%",
                border: 0,
                
              }}
            />
            */}
            <a href="https://www.youtube.com/watch?v=W59Sp8qKs7g" color="cyan">link</a>
          </div>
        </div>

      ),
          width: "70%",
          
        },
      ]}
    />

    <ProjectsPane
      side="right"
      items={[
        {
          title: "Women Respond to Bass",
          sub: "Bedroom Set - Nov 2025",
          desc: "30 minute hard dance mix - quite old but one I'm still happy with! Local preview is on the player, and the setlist is on SC :)",
          content: (
            <div style={{ display: "grid", gap: 8 }}>
              <audio
                ref={registerAudio}
                controls
                preload="auto"
                onPlay={(e) => handleAudioPlay(e.currentTarget)}
                style={{ width: "100%", borderRadius: 32 }}
              >
                <source src={wrtb} type="audio/mpeg" />
              </audio>
            </div>
          ),
          width: "70%",
          
        },
      ]}
    />
    <ProjectsPane
      side="right"
      items={[
        {
          title: "trustfall.flp",
          sub: "Track - Sep 2025",
          desc: "Short track I made - first time learning Serum using preset wavetables for bass/leads - I hope the next tracks pay off from what I have learned since :D",
          content: (
          <div style={{ display: "grid", gap: 8 }}>
          <audio
            ref={registerAudio}
            controls
            preload="auto"
            onPlay={(e) => handleAudioPlay(e.currentTarget)}
            style={{ width: "100%", borderRadius: 32 }}
          >
            <source src={trustfall} type="audio/mpeg" />
          </audio>

            {/* edit player */}
            <iframe
              title="SoundCloud player"
              width="100%"
              height="166"
              scrolling="no"
              frameBorder="no"
              allow="autoplay"
              style={{
                borderRadius: 12,
                overflow: "hidden",
              }}
              src={
                "https://w.soundcloud.com/player/?url=" +
                encodeURIComponent(
                  "https://soundcloud.com/blujay-376774419/trustfall"
                ) +
                "&color=%233b82f6&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=false"
              }
            />
          </div>
        )},
      ]}
      
    />
    
    <CornerVisualizer
      audioRef={{ current: activeAudioEl }}
      corner="right"
      birdElRef={logoWrapRef}
      titleRef={branchTitleRef}
      padTop={16}
      padLeft={0}
      padRight={0}
      gapToBird={0}
      overlapPx={36}
      height={36}
    />
    <ToLanding onClick={() => window.location.reload()} />
  </>
)}


{/* CODE PANE */}
{showPane && stage === "code" && (
  <>
    <ProjectsPane
      side="left"
      items={[
        {
          title: "Reactive LED lighting  ",
          sub: "Personal project - Apr-Jun 2026",
        desc: (
        
          <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            components={{
              a: ({ children, ...props }) => (
                <a {...props} target="_blank" rel="noreferrer" style={{ color: "cyan", textDecoration: "underline" }}>
                  {children}
                </a>
              ),
              p: (props) => (
                <p {...props} style={{ margin: "0 0 0.9em", lineHeight: 1.5 }} />
              ),
            }}
          >
            {electronicsNotes}
          </ReactMarkdown>
        ),
          content: (
            <div style={{ display: "grid", gap: 8 }}>
              <div>
              </div>
              <div style={{ opacity: 0.8 }}>
                {/* GitHub: <a href="https://github.com/sc22j4s/Individual-Project" target="_blank" rel="noreferrer" style={{ color: "cyan", textDecoration: "underline" }}>sc22j4s/Individual-Project</a> */}
                Github: <a href="mailto:blujay.nest@pm.me?subject=Electronics%20Project%20Enquiry" target="_blank" rel="noreferrer" style={{ color: "cyan", textDecoration: "underline" }}>[request access!]</a>
              </div>
              
            </div>
          ),
        },
        

        {
          title: "Self-supervised ML Genre Classification",
          sub: "Final Year Project - August 2025",
        desc: (
        
          <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            components={{
              a: ({ children, ...props }) => (
                <a {...props} target="_blank" rel="noreferrer" style={{ color: "cyan", textDecoration: "underline" }}>
                  {children}
                </a>
              ),
              p: (props) => (
                <p {...props} style={{ margin: "0 0 0.9em", lineHeight: 1.5 }} />
              ),
            }}
          >
            {openl3Notes}
          </ReactMarkdown>
        ),
          content: (
            <div style={{ display: "grid", gap: 8 }}>
              <div style={{ opacity: 0.8 }}>
                <img
                  src={hiphop_chart}
                  alt="UMAP of experimental / hip-hop dataset"
                   style={{
                  display: "block",
                  width: "clamp(280px, 55vw, 960px)", // min → fluid → max
                  maxWidth: "100%",
                  height: "auto",
                  objectFit: "contain",
                  margin: "0 auto", // center on wide screens
                  }}
                  className={`logo-anim ${flipStage ? `flip-${flipStage}` : ""}`}
                />
                
              </div>
              <div style={{ opacity: 0.8 }}>
                {/* GitHub: <a href="https://github.com/sc22j4s/Individual-Project" target="_blank" rel="noreferrer" style={{ color: "cyan", textDecoration: "underline" }}>sc22j4s/Individual-Project</a> */}
                Github: <a href="mailto:blujay.nest@pm.me?subject=FYP%20Project%20Enquiry" target="_blank" rel="noreferrer" style={{ color: "cyan", textDecoration: "underline" }}>[request access!]</a>
              </div>
              
            </div>
          ),
        },
        {
  title: "Ableton Launchpad Game Controller [OLD]",
  sub: "Personal Project - July 2024/??",
  desc: (
    (() => {
      const [before = "", after = ""] = (launchpad ?? "").split("---VIDEO---");
      return (
        <>
          <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            components={{
              a: ({ children, ...props }) => (
                <a {...props} target="_blank" rel="noreferrer" style={{ color: "cyan", textDecoration: "underline" }}>
                  {children}
                </a>
              ),
              p: (props) => (
                <p {...props} style={{ margin: "0 0 0.9em", lineHeight: 1.5 }} />
              ),
            }}
          >
            {before}
          </ReactMarkdown>

          <video
            key={demoMp4}                 // force render if path changes
            controls
            playsInline
            muted
            preload="auto"                     // ensure a request happens
            style={{ maxWidth: "100%", borderRadius: 12, margin: "1em 0" }}
            onError={(e) => console.error("VIDEO ERROR", e.currentTarget.currentSrc)}
            justifyContent="center"
          >
            <source src={demoMp4} type="video/mp4" />
          </video>

          <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            components={{
              a: ({ children, ...props }) => (
                <a {...props} target="_blank" rel="noreferrer" style={{ color: "cyan", textDecoration: "underline" }}>
                  {children}
                </a>
              ),
              p: (props) => (
                <p {...props} style={{ margin: "0 0 0.9em", lineHeight: 1.5 }} />
              ),
            }}
          >
            {after}
          </ReactMarkdown>
        </>
      );
    })()
  ),
  content: (
    <>
      <div style={{ opacity: 0.8 }}>
        GitHub: <a href="mailto:blujay.nest@pm.me?subject=%20Launchpad%20Game%20Enquiry" target="_blank" rel="noreferrer" style={{ color: "cyan", textDecoration: "underline" }}>[request access!]</a>
        {/* GitHub: <a href="https://github.com/blujayed/launchpad-game" target="_blank" rel="noreferrer" style={{ color: "cyan", textDecoration: "underline" }}>blujayed/launchpad-game</a> */}
      </div>
    </>
    )
},
  {
    title: "Spotify RYM Integration [WIP]",
    sub: "Personal Project - Sept 2025",
    desc: (
            
              <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                components={{
                  a: ({ children, ...props }) => (
                    <a {...props} target="_blank" rel="noreferrer" style={{ color: "cyan", textDecoration: "underline" }}>
                      {children}
                    </a>
                  ),
                  p: (props) => (
                    <p {...props} style={{ margin: "0 0 0.9em", lineHeight: 1.5 }} />
                  ),
                }}
              >
                {spicetify}
              </ReactMarkdown>
            ),
      content: (
        <>
          <div style={{ opacity: 0.8 }}>
            {/* GitHub: [none] */}
          </div>
        </>
      )
    },

          
        ]}
      />
   <ToLanding onClick={() => window.location.reload()} />
    </>
  )}

{/* PICTURE PANE */}
{showPane && stage === "picture" && (
  <>
    <ProjectsPane
      side="left"
      items={[
        {
          title: "@blujay.mp3 teaser shoot",
          sub: "Shot & edited Jun 2026",
          desc: "First post on the Instagram profile!  Below are the raw shots from my smartphone and their edits I made in Affinity. I'm quite new to retouching photos in professional software but I used it in attempt to make the the edits look consistent side-by-side. The first four were shot in my room, and the last was shot in a park - the website hyperlink is tagged around the corner... ",          content: (
            <div style={{ display: "grid", gap: 8 }}>
              <img
                src={fullcanvas}
                alt="Photography preview"
                style={{
                  width: "100%",
                  maxWidth: "720px",
                  height: "auto",
                  borderRadius: 12,
                  display: "block",
                  margin: "0 auto",
                }}
              />
            </div>
          ),
        },
      ]}
    />

    <ProjectsPane
      side="left"
      items={[
        {
          title: "Gig diary!",
          sub: "2024 - present",
          desc: "Every gig I go to I try to get a shot of the leading artist and support(s) as a way of remembering them (unless deemed inappropriate!). As a ritual I edited them on my phone before posting them online. Below are some of my favourites (along with some artist recognition!)",
          content: (
            <div style={{ opacity: 0.8, color: "#3bcaf6" }}>
              [lots of pictures to come...]
            </div>
          ),
        },
      ]}
    />


    <ToLanding onClick={() => window.location.reload()} />
  </>
)}

</div>
);
}


function LogoLink({ icon, alt, href }) {
  return (
    <button
      type="button"
      onClick={() => window.open(href, "_blank", "noopener,noreferrer")}
      aria-label={alt}
      style={{
        border: "none",
        background: "transparent",
        padding: 0,
        cursor: "pointer",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <img
        src={icon}
        alt=""
        aria-hidden="true"
        style={{
          width: "clamp(24px, 5vw, 38px)",
          height: "auto",
          display: "block",
          objectFit: "contain",
        }}
      />
    </button>
  );
}

function ProjectsPane({ side = "right", items = [] }) {
  return (
    <div
      style={{
        ...paneStyles.wrap,
        alignItems: side === "right" ? "flex-end" : "flex-start",
        opacity: 0,
        transform: "translateY(20px)",
        animation: `paneIn ${TIME}ms ease forwards`,
        animationDelay: "300ms",
      }}
    >
      <div style={paneStyles.scroller} role="list">
        {items.map((p, i) => (
          <ProjectCard key={i} {...p} />
        ))}
      </div>
    </div>
  );
}

function ProjectCard({ title, sub, desc, desc2,content }) {
  return (
    <article style={cardStyles.card} role="listitem">
      <header style={cardStyles.header}>
        <h2 style={cardStyles.title}>{title}</h2>
        {sub && <div style={cardStyles.sub}>{sub}</div>}
      </header>
      {desc && <p style={cardStyles.desc}>{desc}</p>}
      <div style={cardStyles.body}>
        {content}
      </div>
    </article>
  );
}

function ToLanding({ onClick }) {
  return (
    <button style={{ ...styles.button,
      padding: "12px 12px",
      fontSize: "1.25rem",
      position: "fixed",
      bottom: "16px",
      zIndex: 30,
      opacity: 0.8,
      color: "white",
      borderColor: "grey",
      left: "50%",
      transform: "translateX(-50%)",
      backgroundColor: "black",
    }} onClick={onClick}>back</button>
  );
}

const styles = {
  splashText: {
    marginTop: "0.5rem",
    fontSize: "clamp(20px, 3vh, 36px)",
    fontFamily: "Courier New, monospace",
    color: "#3bcaf6",
    textTransform: "lowercase",
    justifyContent: "center",
    textShadow: `
  0 0 4px rgba(59, 130, 246, 0.9),
  0 0 12px rgba(59, 130, 246, 0.7),
  0 0 46 rgba(59, 130, 246, 0.45)
`,
  },

  splashText2: {
    justifyContent: "center",
    textAlign: "center",
    fontSize: "clamp(8px, 3vh, 16px)",
  },

  
  
  splashLogo: {
    marginTop: "0.5rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padLeft: "0.6rem",
  },
 
  container: {
    height: "100dvh",
    width: "100vw",
    overflow: "hidden",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#00010aff",
    color: "white",
    fontFamily: "Bitcounter, Courier New, monospace",
    flexDirection: "column", // vertical stack
  },
  content: {
    display: "flex",
    flexDirection: "column",  // logo+text above, button below
    alignItems: "center",
  },
  logoText: {
    display: "flex",
    alignItems: "center",
    marginBottom: "0rem",
  },

  socialLinks: {
    display: "flex",
    gap: "clamp(18px, 3vw, 34px)",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "42px",
    width: "100%",
  },
    
  text: {
    fontSize: "clamp(28px, 6vh, 68px)",    // responsive title
    lineHeight: 1,
    margin: 0,
    animation: "none",
    fontFamily: "Bitcounter, Courier New, monospace",
  },
  buttonWrap: {
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
  alignItems: "center",
  justifyContent: "center",
  marginTop: "1rem",
  width: "100%",
},
  buttonContainer: {
    marginTop: "1rem",
  },
  button: {

    height: "5vh",                 // keep if you like the vh-based height
    minHeight: "44px",             // touch target safety
    width: "40vh",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",

    padding: "18px 24px",
    fontSize: "1.5rem",
    fontFamily: "Courier New",
    border: `2px solid ${BIRDCOLORS.blue}`,
    borderRadius: "8px",
    background: "transparent",
    color: "white",
    cursor: "pointer",
    transition: "all 0.3s ease",

  },
  logoContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "1rem",
    
    width: "auto",
    height: "auto",
    overflow: "visible"
  },
};

/* Projects pane styles */
const paneStyles = {
  wrap: {
    width: "100%",
    display: "flex",
    justifyContent: "stretch",
    marginTop: "0rem",
  },
  scroller: {
    width: "100%",
    maxHeight: "64vh",
    overflowY: "auto",
    padding: "8px",
    display: "grid",
    gap: "12px",
  },


  
};



const cardStyles = {
  card: {
    background: "rgba(255,255,255,0.04)",
    border: "1px solid rgba(255,255,255,0.08)",
    borderRadius: "12px",
    padding: "14px",
    boxShadow: "0 6px 20px rgba(0,0,0,0.25)",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "baseline",
    gap: "16px",
    marginBottom: "6px",
  },
  title: {
    fontSize: "clamp(22px, 3.5vw, 48px)",   // much bigger on wide screens
    margin: 0,
    lineHeight: 1.1,
  },
  sub: {
    opacity: 0.8,
    fontSize: "clamp(14px, 1.25vw, 22px)",
    fontWeight: 600,
    letterSpacing: "0.01em",
  },
  desc: {
    opacity: 0.95,
    fontSize: "clamp(16px, 1.4vw, 24px)",
    lineHeight: 1.5,
    margin: "10px 0 14px",
                // keeps paragraphs readable on desktop
    fontFamily: "Courier New, monospace",
    color: `${BIRDCOLORS.blue}`
  },
  body: {
    // minHeight: "80px",     // space for embeds/content
    display: "grid",
    alignItems: "start",
  },
};

